import { useEffect } from 'react';
import { useHowlerStore } from 'services/HowlerService';

function composedPath(el) {
  const path = [];

  let safeCounter = 0;
  while (el) {
    safeCounter++;
    if (safeCounter === 20) {
      // eslint-disable-next-line no-console
      console.warn('could not terminate loop');
      return path;
    }
    path.push(el);
    el = el.parentElement;
  }
  return path;
}

export default function() {
  const playClickUiSound = useHowlerStore(state => state.playClickUiSound);
  useEffect(() => {
    const handleClick = event => {
      let path = event.path;
      if (!path) {
        path = composedPath(event.target);
      }
      for (let i = 0; i < path.length; i++) {
        const element = path[i];
        if (element.dataset) {
          const { soundAction } = element.dataset;

          if (soundAction && soundAction === 'click') {
            // play sound
            playClickUiSound();
            break;
          }
        }
      }
    };

    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);
  return null;
}
